import { render, staticRenderFns } from "./registerPaymentCard.vue?vue&type=template&id=6b19dad7&scoped=true"
import script from "./registerPaymentCard.vue?vue&type=script&lang=js"
export * from "./registerPaymentCard.vue?vue&type=script&lang=js"
import style0 from "./registerPaymentCard.vue?vue&type=style&index=0&id=6b19dad7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b19dad7",
  null
  
)

export default component.exports